import { render, staticRenderFns } from "./PdfThumbnail.vue?vue&type=template&id=3404fe86&scoped=true&"
import script from "./PdfThumbnail.vue?vue&type=script&lang=js&"
export * from "./PdfThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./PdfThumbnail.vue?vue&type=style&index=0&id=3404fe86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3404fe86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3404fe86')) {
      api.createRecord('3404fe86', component.options)
    } else {
      api.reload('3404fe86', component.options)
    }
    module.hot.accept("./PdfThumbnail.vue?vue&type=template&id=3404fe86&scoped=true&", function () {
      api.rerender('3404fe86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/designed/user/components/PdfThumbnail.vue"
export default component.exports